
var Params 					= require("$root/common/variables/Params.es6");
var Util 						= require("$root/common/util/Util.es6");
var easing 					=	require("jquery.easing");
window.$ 						= require("jquery");
window.Jquery 			= window.$

//localStorageの下方互換を確保
if (!window.localStorage)
{
	window.localStorage = {};
}

window.$.wait = function(msec) {
	var df_ = new $.Deferred;
	setTimeout(function(){df_.resolve(msec);}, msec);
	return df_.promise();
};



class Main
{

	constructor()
	{

		//Params.IS_MOBILE = Params.MOBILE_VIEW.indexOf(Util.getUserAgent()) != -1;
		//Params.IS_TABLET = Params.TABLET_VIEW.indexOf(Util.getUserAgent()) != -1;
		
		// Check for iPad specifically using platform (works better for older iPads)
		const userAgent = navigator.userAgent.toLowerCase();
		const platform = navigator.platform;
		const isIPad = /iPad/.test(platform) || 
			(/MacIntel/.test(platform) && navigator.maxTouchPoints > 1 && !window.MSStream);
		Params.IS_TABLET = isIPad || 
			/(tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|silk)/.test(userAgent);
		Params.IS_MOBILE = !Params.IS_TABLET && 
			/(iphone|ipod|android.*mobile|mobile safari|blackberry|bb10|opera mini|opera mobi)/.test(userAgent);

		this.isStart = false;
		this.timer = -1;
		this.pastMouseX = 0;
		this.body = $("body");
		this.menu = $("#menu");
		this.menuIcon = $("#menu_icon");
		this.wrapper = $("#wrapper");
		this.isOpenMenu = false;
		this.header = $("#header");
		this.headerIcon = null;
		this.cv = $("#cover");
		this.slides = [];
		this.tp_graphic = $("#top_graphic");
		this.slides[0] = $(".result");
		this.slides[1] = $(".talkshow");
		this.ticker = 0;

		this.mouseOver = false;

		this.slides[0].mouseover(()=>{this.mouseOver = true});
		this.slides[0].mouseout(()=>{this.mouseOver = false});

		this.slides[1].mouseover(()=>{this.mouseOver = true});
		this.slides[1].mouseout(()=>{this.mouseOver = false});

		this.$award = $("#award");
	
		if(this.$award[0])
		{
			
			this.$descs = this.$award.find(".desc");
			this.$comments = this.$award.find(".comments");
		}

		if(this.header[0])
		{
			this.headerIcon = $(this.header.find(".icon"));
		}

		window.addEventListener("resize", ()=>{this.onResize();});

		this._isTouchEnvironment = () => window.matchMedia("(hover: none), (pointer: coarse)").matches;
		this._isPcNarrow = () => !this._isTouchEnvironment() && $(window).width() <= 640;
		this._isTouchMode = () => this._isTouchEnvironment() || this._isPcNarrow();
		// 640px以下のcover高さモード（年ごとの切替用）
		// auto: 固定しない / full: window高さ
		const coverMode = window.SNDC_COVER_HEIGHT_MODE || "auto";
		this._coverNarrowMode = (coverMode + "").toLowerCase();

		const openMenu = () => {
			this.menu.addClass("open");
			this.header.addClass("menu-open");
			this.wrapper.addClass("menu-open");
			this.body.addClass("menu-open");
			this.isOpenMenu = true;
		};
		const closeMenu = () => {
			this.menu.removeClass("open");
			this.header.removeClass("menu-open");
			this.wrapper.removeClass("menu-open");
			this.body.removeClass("menu-open");
			this.isOpenMenu = false;
		};
		const toggleMenu = () => {
			if (!this.isOpenMenu) openMenu();
			else closeMenu();
		};

		// マウス追従は常時バインドして、モード切り替え時の再読込依存をなくす
		$(document).mousemove((e)=>
			{
				this.mouseX = e.pageX;
				this.mouseY = e.pageY;
				if(this.pastMouseX == 0) this.pastMouseX = this.mouseX;
			}
		).mouseover();

		// iosのバグ対策(https://xn--nckmepf1g6g.com/2022/06/24/touchmove/)
		this.menuIcon.parent().on("touchend", ()=>{});
		this.menuIcon.on("touchend", (e) => {
			if (!this._isTouchEnvironment()) return;
			e.preventDefault();
			var touch = e.originalEvent.changedTouches[0];
			var target = document.elementFromPoint(touch.clientX, touch.clientY);
			if (target !== this.menuIcon[0]) return;
			toggleMenu();
		});

		let touchStartTime = 0;
		let touchStartX = 0;
		let touchStartY = 0;
		this.menu.on("touchstart", (e) => {
			if (!this._isTouchEnvironment()) return;
			touchStartTime = e.timeStamp;
			touchStartX = e.originalEvent.touches[0].clientX;
			touchStartY = e.originalEvent.touches[0].clientY;
		});
		this.menu.on("touchend", (e) => {
			if (!this._isTouchEnvironment()) return;
			if (e.target.tagName.toLowerCase() === 'a') {
				setTimeout(() => {
					if (this.isOpenMenu) closeMenu();
				}, 100);
				return;
			}

			let touchEndTime = e.timeStamp;
			let touchEndX = e.originalEvent.changedTouches[0].clientX;
			let touchEndY = e.originalEvent.changedTouches[0].clientY;
			let deltaX = Math.abs(touchEndX - touchStartX);
			let deltaY = Math.abs(touchEndY - touchStartY);

			if (touchEndTime - touchStartTime < 160 && deltaX < 10 && deltaY < 10) {
				if (this.isOpenMenu) closeMenu();
			}
		});

		// PCで640px以下はclickで開閉（touchイベントが発火しないため）
		this.menuIcon.on("click", (e) => {
			if (!this._isPcNarrow()) return;
			e.preventDefault();
			toggleMenu();
		});
		this.menu.on("click", (e) => {
			if (!this._isPcNarrow()) return;
			if (e.target.tagName.toLowerCase() === 'a') {
				setTimeout(() => {
					if (this.isOpenMenu) closeMenu();
				}, 100);
				return;
			}
			if (this.isOpenMenu) closeMenu();
		});

		this.menus = this.menu.find("li");

		for(var i = 0; i < this.menus.length; i++)
		{
			if(!$(this.menus[i]).hasClass("n"))
			{
				var s_ = $(this.menus[i]).find("a");
				if(s_)
				s_.on("click",(e)=>{this.changeHash();});
			}
		}

		this.onResize();
		if(this.cv[0]) this.changeHash();

		var count = 0;
		if(this.slides[count].length > 0)
			this.slides[count].addClass("show");

		//アニメーションをやめたのでコメントアウト
		/*
		setInterval(() => {
			if(this.mouseOver) return;
			var next = (count + 1) % this.slides.length;
			if(this.slides[next].length == 0) return;
			this.slides[count].removeClass("show");
			count = next % this.slides.length;
			this.slides[count].addClass("show");
		}, 3000);
		*/

		requestAnimationFrame(()=>{this.update();})
	}

	changeHash()
	{
		clearTimeout(this.hashTimer);
		this.hashTimer = setTimeout(
			()=>
			{
				var _scroll = 0;
				var hash_ = location.hash;

				// 実在するIDへの移動はブラウザー標準のアンカー処理に任せる。
				if(document.getElementById(hash_.slice(1))) return;

				switch(hash_)
				{
					case "#01":
						_scroll = $("#top > .section01").get( 0 ).offsetTop
						break;
					case "#02":
						_scroll = $("#top > .section02").get( 0 ).offsetTop
						break;
					case "#03":
						_scroll = $("#top > .section03").get( 0 ).offsetTop
						break;
					case "#04":
						_scroll = $("#top > .section04").get( 0 ).offsetTop
						break;
					case "#05":
						_scroll = $("#top > .section05").get( 0 ).offsetTop
						break;
				}
				console.log(_scroll)
				if(_scroll > 0) $('html,body').animate({scrollTop: _scroll-100}, 500, 'easeOutQuart');
			}
		,200)

	}

	update()
	{
		if (this._isTouchMode()) {
			this.menuIcon.removeClass("hide");
		} else {
			if (!this.isOpenMenu && this.mouseX < 100) {
				this.menu.addClass("open");
				this.header.addClass("menu-open");
				this.wrapper.addClass("menu-open");
				this.body.addClass("menu-open");
				this.isOpenMenu = true;
				// this.menuIcon.addClass("hide")
			} else if (this.isOpenMenu && this.mouseX > 340) {
				this.menu.removeClass("open");
				this.header.removeClass("menu-open");
				this.wrapper.removeClass("menu-open");
				this.body.removeClass("menu-open");
				this.isOpenMenu = false;
				// this.menuIcon.removeClass("hide")
			}

			var hideMenuFlag = false;
			if (
				location.pathname == "/" ||
				/\/archives\/\d+th\//.test(location.pathname)
			) {
				hideMenuFlag = true;
			}

			if(this.body.scrollTop() < $(window).height() - 80 && hideMenuFlag)
			{
				if(this.mouseX != this.pastMouseX || this.body.scrollTop() != this.pastScroll)
				{
					clearTimeout(this.timer);
					this.timer = setTimeout(
						()=>
						{
							this.menuIcon.addClass("hide")
						}
					,1000);
					this.menuIcon.removeClass("hide")
				}
			}
			else {
				clearTimeout(this.timer);
				this.menuIcon.removeClass("hide")
			}

			this.pastScroll = this.body.scrollTop();
			this.pastMouseX = this.mouseX;
		}

		if(this.headerIcon)
		{
			// if(this.body.scrollTop() > 40)
			// {
			// 	this.headerIcon.show()
			// }
			// else {
			// 	this.headerIcon.hide()
			// }
		}
		
		var yt = $(".yt");
		if(yt.length > 0) {
			$(yt).height($(yt).width() * 0.5625);
		}
		requestAnimationFrame(()=>{this.update();})
	}

	onResize()
	{

		if(this.cv[0]){
			const isPcNarrow = !Params.IS_MOBILE && !Params.IS_TABLET && $(window).width() <= 640;
			// PCで640px以下のときのみ、タブレット寄りのcoverクラスに寄せる
			if(isPcNarrow){
				this.cv.addClass("w");
				this.cv.removeClass("h");
			}
			else if($(window).width() > $(window).height()){
				this.cv.addClass("h");
				this.cv.removeClass("w");
			}
			else {
				this.cv.addClass("w");
				this.cv.removeClass("h");
			}
		}

		if(this.$award[0])
		{
			for (let i = 1; i < this.$descs.length; i++) 	$(this.$descs[i]).height("auto");
			for (let i = 1; i < this.$comments.length; i++) $(this.$comments[i]).height("auto");
			for (let i = 1; i < this.$descs.length; i+=2){
				var h_ = $(this.$descs[i]).height();
				h_ = h_ > $(this.$descs[i+1]).height() ? h_ : $(this.$descs[i+1]).height();
				$(this.$descs[i]).height(h_);
				$(this.$descs[i+1]).height(h_);
			}

			for (let i = 1; i < this.$comments.length; i+=2){
				var h_ = $(this.$comments[i]).height();
				h_ = h_ > $(this.$comments[i+1]).height() ? h_ : $(this.$comments[i+1]).height();
				$(this.$comments[i]).height(h_);
				$(this.$comments[i+1]).height(h_);
			}
		}

		// 通常トップだけNews分の高さを調整し、アーカイブは年度側の処理に任せます。
		if (!this.cv[0]) return false;
		if (this.cv.closest("#top").length) {
			if ($(window).width() <= 640) {
				if (this._coverNarrowMode === "full") {
					this.cv.height($(window).height());
				} else {
					this.cv.css("height", "");
				}
			} else {
				this.cv.height($(window).height() - 80);
			}
		}

		var s_ = 80;
		var st_ = 80;
		if($(window).width() < 641)
		{
			s_ = 30;
			st_ = 80;
		}

		// $(this.mr).css("top", (this.cv.height()-$(this.mr).height())/2)
		// var brh_ = $(this.br).height();
		// var tly_ = $(this.tl).offset().top;
		// var tlh_ = $(this.tl).height();

		// $(this.mr).css("top", tly_ + tlh_ + tlh_*0.3);

		// var mry_ = $(this.mr).offset().top;
		// var mrh_ = $(this.mr).height();

		// $(this.ml).css("top", mry_ + mrh_ + tlh_*0.3);

		// if($(window).height() < try_ + trh_  + s_*2 + brh_ + s_+3) $(this.br).css("top", try_ + trh_ + trh_*0.2);
		// else  $(this.br).css("top", "auto");


		if(!this.isStart)
		{
			this.wrapper.removeClass("hide")
			// $(this.tl).removeClass("hide")
			// $(this.br).removeClass("hide")
			// $(this.mr).removeClass("hide")
			this.isStart = true;
		}
		
	}
}


$(document).ready(
	function()
	{
		var main = new Main();
	}
);

module.exports = Main;
